// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__NDsSR","text_container":"Alert_text_container__Vqzjj","title_text":"Alert_title_text__qn_tW","text":"Alert_text__7juHR","icon":"Alert_icon__HX_DX"};